export default __webpack_public_path__ + "static/media/misc-bathtubA-2048w.42a5d9e2.webp";